import React from "react";
import FormattedDate from "./FormattedDate";
import WeatherIcon from "./WeatherIcon";
import WeatherTemperature from "./WeatherTemperature";

export default function WeatherInfo(props) {
  return (
    <div>
      <div>
        <h1 className="city"> {props.data.city}</h1>
      </div>

      <div className="row">
        <h5 className="date">
          {" "}
          <FormattedDate date={props.data.date} />
        </h5>
      </div>

      <div className="row">
        <div className="description">{props.data.description}</div>
      </div>

      <div className="row">
        <div className="mainTemp">
          <div className="child">
            {" "}
            <WeatherIcon code={props.data.icon} />
          </div>
          
          <div className="child">
            {" "}
            <WeatherTemperature celsius={props.data.temperature} />
          </div>
          
        </div>
      </div>
    </div>
  );
}
